<section class="contact" id="contacto">
  <div class="contact__inner">

    <!-- Heading -->
    <div class="contact__heading">
      <h1 class="h1" style="color: var(--color-primary-950);">¿Te apetece vivir una experiencia con Aruma?</h1>
      <p class="body-m" style="color: var(--color-neutral-950);">
        Talleres, retiros o experiencias privadas. Apúntate a tu taller preferido o cuéntanos qué te
        interesa, te ayudamos a diseñar una experiencia a medida.
      </p>
    </div>

    <!-- Form + info side by side -->
    <div class="contact__body">

      <!-- Form -->
      <div class="contact__form-wrap">
        @if (!submitted()) {
          <form class="contact__form" (ngSubmit)="onSubmit()" novalidate>

            <div class="contact__field">
              <label class="contact__label body-s" for="nombre">Nombre</label>
              <input
                class="contact__input"
                id="nombre"
                type="text"
                name="nombre"
                [(ngModel)]="form.nombre"
                placeholder="Tu nombre"
                required
              >
            </div>

            <div class="contact__field">
              <label class="contact__label body-s" for="email">Email</label>
              <input
                class="contact__input"
                id="email"
                type="email"
                name="email"
                [(ngModel)]="form.email"
                placeholder="tuemail@ejemplo.com"
                required
              >
            </div>

            <div class="contact__field">
              <label class="contact__label body-s" for="telefono">Teléfono</label>
              <input
                class="contact__input"
                id="telefono"
                type="tel"
                name="telefono"
                [(ngModel)]="form.telefono"
                placeholder="600 000 000"
              >
            </div>

            <div class="contact__field">
              <label class="contact__label body-s" for="interes">¿Qué te interesa?</label>
              <select
                class="contact__input contact__select"
                id="interes"
                name="interes"
                [(ngModel)]="form.interes"
              >
                <option value="" disabled selected>Selecciona una opción</option>
                @for (opcion of intereses; track opcion) {
                  <option [value]="opcion">{{ opcion }}</option>
                }
              </select>
            </div>

            <div class="contact__field contact__field--full">
              <label class="contact__label body-s" for="mensaje">Mensaje (opcional)</label>
              <textarea
                class="contact__input contact__textarea"
                id="mensaje"
                name="mensaje"
                [(ngModel)]="form.mensaje"
                placeholder="Cuéntanos qué tienes en mente…"
                rows="4"
              ></textarea>
            </div>

            @if (error()) {
              <p class="contact__error body-s">Por favor, completa los campos obligatorios (nombre y email).</p>
            }

            <button type="submit" class="btn btn-primary contact__submit">
              Enviar consulta
            </button>

          </form>
        } @else {
          <div class="contact__success">
            <div class="contact__success-icon" aria-hidden="true">
              <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="24" cy="24" r="23.5" stroke="var(--color-primary-500)"/>
                <path d="M14 24l7 7 13-14" stroke="var(--color-primary-500)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <h3 class="h3-s" style="color: var(--color-primary-950);">¡Mensaje recibido!</h3>
            <p class="body-m" style="color: var(--color-neutral-950);">
              Te responderemos en breve. Mientras tanto, síguenos en Instagram para estar al día de nuestros próximos talleres.
            </p>
          </div>
        }
      </div>

      <!-- Side info -->
      <div class="contact__info">
        <div class="contact__info-block">
          <span class="contact__info-label label-caps">Email</span>
          <a href="mailto:arumaturismo@gmail.com" class="contact__info-link body-s">arumaturismo&#64;gmail.com</a>
        </div>
        <div class="contact__info-block">
          <span class="contact__info-label label-caps">Whatsapp</span>
          <a href="https://wa.me/34111222666" target="_blank" rel="noopener" class="contact__info-link body-s">111 222 666</a>
        </div>
        <div class="contact__info-block">
          <span class="contact__info-label label-caps">Instagram</span>
          <a href="https://instagram.com/arumaturismo" target="_blank" rel="noopener" class="contact__info-link body-s">&#64;arumaturismo</a>
        </div>
        <div class="contact__info-block">
          <span class="contact__info-label label-caps">TikTok</span>
          <a href="https://tiktok.com/@arumaturismo" target="_blank" rel="noopener" class="contact__info-link body-s">&#64;arumaturismo</a>
        </div>
      </div>

    </div>
  </div>
</section>
